import { BeforeRequestMiddleware } from '../types';

/**
 * Set the `x-requested-with` header to help Django's with `request.is_ajax()`.
 */
export const ajax: BeforeRequestMiddleware = (init) => {
  init.headers.set('x-requested-with', 'XMLHttpRequest');
  return init;
};
